var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImIdL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 30,
    viewBox: "0 0 103 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5374_6852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5374_6852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.474 0H0V30H102.474V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5374_6852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37235 8.55957H0.906345C0.405785 8.55957 0 8.96537 0 9.46592V29.0506C0 29.551 0.405785 29.957 0.906345 29.957H3.37235C3.87291 29.957 4.2787 29.551 4.2787 29.0506V9.46592C4.2787 8.96537 3.87291 8.55957 3.37235 8.55957Z",
    fill: "#072F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37235 0.0457764H0.906345C0.405785 0.0457764 0 0.451561 0 0.95212V3.96195C0 4.4625 0.405785 4.86827 0.906345 4.86827H3.37235C3.87291 4.86827 4.2787 4.4625 4.2787 3.96195V0.95212C4.2787 0.451561 3.87291 0.0457764 3.37235 0.0457764Z",
    fill: "#072F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0957 8.00483C36.8699 8.00483 32.6837 9.95157 31.0164 13.0974C29.4341 9.63814 27.1457 8.00483 23.1482 8.00483C19.9704 8.00483 16.6075 9.36622 14.7797 11.8134L14.4549 9.34923C14.3964 8.89796 14.0112 8.56184 13.5561 8.56184H11.4923C10.9919 8.56184 10.5859 8.9678 10.5859 9.4682V29.0527C10.5859 29.5531 10.9919 29.9591 11.4923 29.9591H13.8733C14.3737 29.9591 14.7797 29.5531 14.7797 29.0527V19.4739C14.7797 17.4648 16.2732 11.4546 23.1482 11.4546C30.0233 11.4546 29.0054 16.9644 29.0054 18.8319V29.0509C29.0054 29.5513 29.4114 29.9572 29.9118 29.9572H32.2928C32.7932 29.9572 33.1991 29.5513 33.1991 29.0509V19.5588C33.1991 13.6242 37.3534 11.4527 41.0976 11.4527C45.4991 11.4527 46.5697 13.9357 46.5697 18.83V29.049C46.5697 29.5494 46.9757 29.9553 47.4761 29.9553H49.8571C50.3575 29.9553 50.7634 29.5494 50.7634 29.049V19.0868C50.7634 16.0845 51.6754 8.00293 41.0976 8.00293L41.0957 8.00483Z",
    fill: "#072F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6796 0.0458984H63.9875C64.6126 0.0458984 65.1205 0.553828 65.1205 1.17883V28.8676C65.1205 29.4927 64.6126 30.0006 63.9875 30.0006H58.6796C58.0548 30.0006 57.5469 29.4927 57.5469 28.8676V1.17883C57.5469 0.553828 58.0548 0.0458984 58.6796 0.0458984Z",
    fill: "#7BE582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8331 21.165L86.1511 24.8941C85.6676 25.3833 84.8822 25.3852 84.3968 24.9019L78.2337 18.2628V9.14086L85.2485 16.639L97.7088 4.0219C95.0332 1.52757 91.4456 0 87.5011 0H73.0392C72.4141 0 71.9062 0.50793 71.9062 1.13293V28.8237C71.9062 29.4488 72.4141 29.9566 73.0392 29.9566H87.5011C95.7734 29.9566 102.478 23.2515 102.478 14.9792C102.478 13.023 102.099 11.1556 101.417 9.44297L89.8331 21.1669V21.165Z",
    fill: "#7BE582"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5374_6852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.656,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImIdL);
export default __webpack_public_path__ + "static/media/imId-l.74840c2a701990e9b56a0b86ff7d761c.svg";
export { ForwardRef as ReactComponent };